import type { MantineThemeComponents } from '@mantine/core';
import { colors } from './colors';
import { layout } from './layout';

/**
 * Mantineコンポーネントのデフォルトスタイル
 */
export const components: MantineThemeComponents = {
  Paper: {
    defaultProps: {
      shadow: 'sm',
      radius: layout.border.radius,
    },
  },

  ActionIcon: {
    defaultProps: {
      variant: 'subtle',
      color: 'gray',
    },
  },

  Text: {
    styles: {
      root: {
        color: colors.gray[900],
      },
    },
  },
};
